import React, { ChangeEvent, FC, useState } from 'react';
import styled from 'styled-components';
import { StyledTemplate } from './StyledTemplate';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';
import { ITemplate } from '@entities/card/types';
import { useDispatch, useSelector } from 'react-redux';
import { clientSelect } from '@entities/client';
import { AppDispatch } from '@config/store';
import { authInfoSelect } from '@entities/auth';
import { updateClientComment } from '@api/thunks/clients';

interface PropsClientModal {
    setOpeningSettingsPopup: (val: boolean) => void;
}

const ContentModalInfo: FC<PropsClientModal> = ({
    setOpeningSettingsPopup,
}) => {
    const { favoriteProducts, selectedClient } = useSelector(clientSelect);
    const [comment, setComment] = useState<string>(
        selectedClient?.comment || ''
    );
    const { shop } = useSelector(authInfoSelect);

    const dispatch = useDispatch<AppDispatch>();

    const handleSaveModal = () => {
        if (!selectedClient || !shop) return;
        if (comment && comment !== selectedClient.comment) {
            dispatch(
                updateClientComment({
                    text: comment,
                    client_id: selectedClient.id,
                    shop_id: shop.id,
                })
            );
        }

        setOpeningSettingsPopup(false);
    };

    return (
        <Wrapper>
            <ContentInfoWrapper>
                <Hr />
                <StyledTableWrapper>
                    <StyledTableHeader>
                        <HeaderTitle style={{ justifyContent: 'flex-start' }}>
                            Найменование
                        </HeaderTitle>
                        <HeaderTitle>Категория</HeaderTitle>
                        <HeaderTitle>Количество</HeaderTitle>
                        <HeaderTitle>Макет</HeaderTitle>
                    </StyledTableHeader>
                    <Br />
                    <StyledTableBody>
                        {favoriteProducts?.map(
                            (item, ind) =>
                                ind <= 2 && (
                                    <InfoWrap key={`infoWrap1-${ind}`}>
                                        <CommonTd
                                            style={{
                                                justifyContent: 'flex-start',
                                            }}
                                            key={`infoNum1-${ind}`}
                                        >
                                            {item?.name}
                                        </CommonTd>
                                        <CommonTd key={`infoNum2-${ind}`}>
                                            {item?.category || '-'}
                                        </CommonTd>
                                        <CommonTd key={`infoNum3-${ind}`}>
                                            {item?.count}
                                        </CommonTd>
                                        <InfoCardTemplate
                                            key={`infoCardName1-${ind}`}
                                        >
                                            <StyledTemplate
                                                template={
                                                    item?.template as unknown as ITemplate
                                                }
                                                ind={ind}
                                            />
                                        </InfoCardTemplate>
                                    </InfoWrap>
                                )
                        )}

                        {/*<StyledButtonMore onClick={() => loadMore()}>*/}
                        {/*    <span>Показать еще</span>*/}
                        {/*</StyledButtonMore>*/}
                        {/*<InfoWrapper>*/}
                        {/*    Любимый стол: <span>214</span>*/}
                        {/*</InfoWrapper>*/}
                    </StyledTableBody>
                </StyledTableWrapper>
                <TextAriaContainer>
                    <TextAria
                        name="text"
                        value={comment}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                            setComment(e.target.value)
                        }
                        placeholder="Напишите ваше примечание"
                    />
                </TextAriaContainer>
            </ContentInfoWrapper>

            <StyledFooter>
                <ButtonContainer>
                    <StyledButtonClose
                        onClick={() => setOpeningSettingsPopup(false)}
                    >
                        Закрыть
                    </StyledButtonClose>
                    <StyledButtonSave onClick={handleSaveModal}>
                        Сохранить
                    </StyledButtonSave>
                </ButtonContainer>
            </StyledFooter>
        </Wrapper>
    );
};

export default ContentModalInfo;

const CommonTd = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    width: 25%;
    line-height: 15px;
    ${flexMixin('row', 'center', 'center')};
    color: ${colors.grey};
`;
const Wrapper = styled.div`
    ${flexMixin('column', 'space-between', 'center')}
    width: 675px;
    height: 524px;
    z-index: 1205;
    flex: none;
    flex-grow: 0;
`;
const ContentInfoWrapper = styled.div`
    ${flexMixin('column', 'flex-start', 'flex-start')}
    width: 100%;
`;

const StyledTableWrapper = styled.div`
    width: 100%;
`;

const StyledTableHeader = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    width: 100%;
    height: 46px;
`;

const HeaderTitle = styled.div`
    height: 23px;
    width: 25%;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 700,
    })};
    line-height: 23px;
    ${flexMixin('row', 'center', 'center')}
    color: ${colors.grey};
`;

const StyledTableBody = styled.div`
    ${flexMixin('column', 'flex-start', 'center')}
    overflow-y: auto;
    overflow-x: hidden;
    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        border-radius: 50%;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #b30000;
    }

    scrollbar-color: darkgrey ${colors.bgWhite};
    scrollbar-width: thin;
`;

const InfoCardTemplate = styled(CommonTd)`
    color: ${colors.primaryBg};
    padding-left: 8px;
    justify-content: center;
`;

const InfoWrap = styled.div`
    width: 100%;
    ${flexMixin('row', 'space-between', 'center')}
    height: 46px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(143, 143, 143, 0.3);
`;

const StyledButtonClose = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 28px;
    ${flexMixin('column', 'center', 'center')}
    color: #8f8f8f;
    cursor: pointer;
    padding: 5px;
`;

const StyledButton = styled.div`
    ${flexMixin('row', 'center', 'center')}
    padding: 6px 58px;
    gap: 10px;
    cursor: pointer;
    width: 160px;
    height: 40px;
    border-radius: 5px;
    flex: none;
    order: 1;
    flex-grow: 0;
    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        align-items: center;
        text-align: center;
    }
`;

const StyledButtonSave = styled(StyledButton)`
    background: ${colors.primaryBg};
    color: ${colors.cleanWhite};
    &:hover {
        background: ${colors.primaryBgHover};
    }
`;

const StyledFooter = styled.div`
    gap: 34px;
    ${flexMixin('row', 'flex-end', 'center')}
    width: 100%;
    margin-bottom: 10px;
`;

const TextAriaContainer = styled.div`
    width: 40%;
    margin-top: 20px;
`;

const Hr = styled.hr`
    width: 100%;
    height: 0;
    border: 3px solid rgba(143, 143, 143, 0.3);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
`;

const Br = styled.hr`
    width: 100%;
    height: 0;
    border: 1px solid rgba(143, 143, 143, 0.3);
`;

const ButtonContainer = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    gap:34px
`;

const TextAria = styled.textarea`
    position: relative;
    width: 100%;
    height: 120px;
    padding: 10px 10px 0 12px;
    border-radius: 5px;
    color: #1f1e24;
    resize: none;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 15px;
    border: none;
    background: #eeefef;
    &:focus {
        border: 1px solid #e65e20;
        outline: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    &:hover {
        border: 1px solid #e65e20;
        outline: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    &:-webkit-autofill {
        -webkit-transition-delay: 9999s;
    }

    ::placeholder {
        color: #b0b3b5;
        font-size: 10px;
    }

    :-ms-input-placeholder {
        color: #b0b3b5;
    }

    ::-ms-input-placeholder {
        color: #b0b3b5;
    }
`;
